module.exports = __webpack_public_path__ + "img/D3.a94eaa4b.png";